import { useState, useEffect } from "react";
import InputTime from "../InputTime/InputTime";
import deleteIcon from "../../../../../assets/img/delete-icon.svg";
import addIcon from "../../../../../assets/img/addicon.svg";

const InputWeekDay = ({ weekDay, timeVariations, weekDayId, editTimeVariations }) => {
  const [title, setTitle] = useState(weekDay);

  function getWeekDay(weekDay) {
    let days = {
      0: "Domingo",
      1: "Segunda",
      2: "Terça",
      3: "Quarta",
      4: "Quinta",
      5: "Sexta",
      6: "Sábado",
    };
    setTitle(days[weekDay]);
  }

  useEffect(() => {
    getWeekDay(weekDay);
  }, []);

  return (
    <>
      <div className="d-flex flex-column flex-lg-row mb-4">
        <div className="bg-cl-lightgray p-4 col-12 rounded-1 align-items-center">
          <div className="d-flex border-0 col-auto  align-items-center ">
            <>
              <div className="col-12">
                <div className="d-flex">
                  <div className="mb-3 me-auto px-2 rounded-2 ">
                    <span className="text-cl-black-4 ff-univanova fz-16 fw-bold">{title}</span>
                  </div>
                </div>
                <div className="">
                  <InputTime
                    timeVariations={timeVariations}
                    editTimeVariations={editTimeVariations}
                    weekDayId={weekDayId}
                    weekDay={weekDay}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default InputWeekDay;
